var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goodtitlecontainer",style:('color:' + String(_vm.fontcolor))},[_c('div',{staticClass:"goodname"},[_vm._v(_vm._s(_vm.goodname))]),_vm._v(" "),_c('div',{staticClass:"goodinfo"},[_c('h1',[_vm._v(_vm._s(_vm.goodinfo))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-779281e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/comcomponents/GoodTitle.vue
// module id = null
// module chunks = 